import { FilterGroups } from '../components/catalog/FilterGroups';
import { ProductList } from '../components/catalog/ProductList';
import { useProductFilters } from '../hooks/useProductFilters';
import { useProducts } from '../hooks/useProducts';

export function CatalogPage() {
  const { data: products = [], isLoading, isError } = useProducts();
  const { filters, setFilter, filtered, regions } = useProductFilters(products);

  if (isLoading) return <p className="section-pad mono-label">ЗАВАНТАЖЕННЯ…</p>;
  if (isError) return <p className="section-pad mono-label">Не вдалося завантажити товари.</p>;

  return (
    <ProductList
      products={filtered}
      title="Каталог"
      counterLabel="ЗНАЙДЕНО"
      emptyText="За цими фільтрами нічого немає."
      filters={<FilterGroups filters={filters} setFilter={setFilter} regions={regions} />}
    />
  );
}
